const EVENT_SOURCE_PRODUCT_FORM = "product-form";
const EVENT_SOURCE_CART_ITEMS = "cart-items";
const CART_PAGE_PATHNAME = "/cart";
const HEAT_RESISTANT_REQUIRED = "1";
const SHOPIFY_APP_BASE_URL_settings = "https://multi-address-order-30436288b667.herokuapp.com/api";

subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  const source = event?.source || null;
  const productVariantId = event?.productVariantId || null;
  const cartData = event?.cartData || null;

  if (source && cartData) {
    if (productVariantId) {
      checkAndAddHeatResistantProduct(source, productVariantId, cartData);
    } else {
      checkAndRemoveHeatResistantProduct(source, cartData);
      if (isItCartPage()) {
        renderProperProceedToOption(cartData);
      }
    }

    currentcartdataOnchange();
  }
});

async function checkAndAddHeatResistantProduct(
  source,
  productVariantId,
  cartData
) {
  const targetProductForm = document.querySelector(
    `form input[name="id"][value="${productVariantId}"].product-variant-id`
  ).closest('form');
  if (!targetProductForm) {
    return;
  }

  const heatResistantProperty = targetProductForm.querySelector(
    'input[name="heat_resistant_required"]'
  );
  if (!heatResistantProperty) {
    return;
  }

  const heatResistantId = heatResistantProperty.getAttribute(
    'data-heat-resistant-id'
  );

  const isHeatResistantApply = await isApplyHeatResistantSetting();
  if (!isHeatResistantApply) {
    return;
  }

  if ((source === EVENT_SOURCE_PRODUCT_FORM)
    && (heatResistantProperty.value === "1")
    && heatResistantId
    && (cartData?.variant_id === parseInt(productVariantId))
    && (cartData?.quantity === 1)) {
    checkHeatResistantExistsInCart(targetProductForm, heatResistantId);
  }
}

function checkHeatResistantExistsInCart(targetProductForm, heatResistantId) {
  setTargetProductFormLoading(targetProductForm);
  fetch(window.Shopify.routes.root + 'cart.js')
  .then((response) => response.json())
  .then((responseJson) => {
    if (responseJson?.items?.length) {
      let variantExists = false;
      for (let cartItem of responseJson.items) {
        if (cartItem?.variant_id && (cartItem.variant_id == heatResistantId)) {
          variantExists = true;
          break;
        }
      }

      if (variantExists) {
        resetTargetProductFormLoading(targetProductForm);
      } else {
        addHeatResistantProductForProductForm(targetProductForm, heatResistantId);
      }
    } else {
      resetTargetProductFormLoading(targetProductForm);
    }
  })
  .catch((e) => {
    console.error(e);
    resetTargetProductFormLoading(targetProductForm);
  });
}

function addHeatResistantProductForProductForm(
  targetProductForm,
  heatResistantId
) {
  const items = [
    {
      "id": heatResistantId,
      "quantity": 1
    }
  ];
  const url = window.Shopify.routes.root + `cart/add.js`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'items': items
    })
  };

  fetch(url, options)
  .then((response) => response.json())
  .then((responseJson) => {
    if (areRequestItemsEqualsResponseItems(items, responseJson)) {
      refreshCartPageNDrawerUIAfterAdding();
    }
  })
  .catch((e) => {
    console.error(e);
  })
  .finally(() => {
    resetTargetProductFormLoading(targetProductForm);
  });
}

function setTargetProductFormLoading(targetProductForm) {
  targetProductForm?.setAttribute('disabled', 'disabled');
  targetProductForm?.setAttribute('aria-disabled', true);
  const submitButton = targetProductForm?.querySelector('[type="submit"]') || null;
  submitButton?.classList.add('skeleton-loading');
}

function resetTargetProductFormLoading(targetProductForm) {
  const submitButton = targetProductForm?.querySelector('[type="submit"]') || null;
  submitButton?.classList.remove('skeleton-loading');
  targetProductForm?.removeAttribute('aria-disabled');
  targetProductForm?.removeAttribute('disabled');
}

function areRequestItemsEqualsResponseItems(requestItems, response) {
  const responseItems = response?.items || null;
  if (!responseItems) return false;
  if (!Array.isArray(responseItems)) return false;

  return requestItems.every(requestItem => {
    // Find matching response item based on `variant_id`
    const matchingItem = responseItems.find(
      responseItem =>
        Number(responseItem.variant_id) === Number(requestItem.id)
    );

    // Return true if a matching item is found, otherwise false
    return !!matchingItem;
  });
}

function refreshCartPageNDrawerUIAfterAdding() {
  const sectionsNeedToRender =  getSectionsNeedToRenderAfterAdding();
  const rederingSections = sectionsNeedToRender.map((section) => section.section);
  const targetElements = targetCartPageNDrawerElementsForAdding();
  setCartPageNDrawerUILoadingForUpdation(targetElements);
  fetch(window.location.pathname + `?sections=${rederingSections.join()}`)
  .then(response => response.json())
  .then(data => {
    if (Object.keys(data).length) {
      sectionsNeedToRender.forEach(item => {
        if (item.section in data) {
          const html = new DOMParser().parseFromString(data[item.section], 'text/html');
          for (const selector of item.selectors) {
            const targetElement = document.querySelector(selector.source);
            const sourceElement = html.querySelector(selector.target);
            if (targetElement && sourceElement) {
              if (['#cart-icon-bubble', '#cart-icon-bubble-mob'].indexOf(selector.source) != -1) {
                targetElement.innerHTML = sourceElement.innerHTML;
              } else {
                targetElement.replaceWith(sourceElement);
              }
            }
          }
        }
      });
    }
  })
  .catch(error => {
    console.error('Error[refreshCartPageNDrawerUIAfterAdding]:', error);
  })
  .finally(() => {
    resetCartPageNDrawerUILoadingForUpdation(targetElements);
  });
}

function getSectionsNeedToRenderAfterAdding() {
  return [
    {
      section: 'cart-drawer',
      selectors: [
        {
          source: 'cart-drawer-items',
          target: 'cart-drawer-items'
        },
        {
          source: '.cart-drawer__footer',
          target: '.cart-drawer__footer'
        }
      ]
    },
    {
      section: 'cart-icon-bubble',
      selectors: [
        {
          source: '#cart-icon-bubble',
          target: '#shopify-section-cart-icon-bubble'
        }
      ],
    },
    {
      section: 'header-custom',
      selectors: [
        {
          source: '#cart-icon-bubble-mob',
          target: '#cart-icon-bubble-mob'
        }
      ],
    },
  ];
}

function targetCartPageNDrawerElementsForAdding() {
  return [
    '#cart-icon-bubble',
    '#cart-icon-bubble-mob',
  ];
}

function setCartPageNDrawerUILoadingForUpdation(targetElements) {
  for (const targetElement of targetElements) {
    addClassesToElements(
      targetElement,
      ['skeleton-loading']
    );
  }
}

function resetCartPageNDrawerUILoadingForUpdation(targetElements) {
  for (const targetElement of targetElements) {
    removeClassesFromElements(
      targetElement,
      ['skeleton-loading']
    );
  }
}

function addClassesToElements(elementSelector, classes) {
  const elements = document.querySelectorAll(elementSelector);
  if (elements) {
    elements.forEach((element) => {
      for (const cls of classes) {
        if (!element.classList.contains(cls)) {
          element.classList.add(cls);
        }
      }
    })
  }
}

function removeClassesFromElements(elementSelector, classes) {
  const elements = document.querySelectorAll(elementSelector);
  if (elements) {
    elements.forEach((element) => {
      for (const cls of classes) {
        if (element.classList.contains(cls)) {
          element.classList.remove(cls);
        }
      }
    })
  }
}

function checkAndRemoveHeatResistantProduct(source, cartData) {
  const items = cartData?.items || [];
  const removedItems = cartData?.items_removed || [];
  if ((source === EVENT_SOURCE_CART_ITEMS)
    && items.length
    && removedItems.length
  ) {
    checkHeatResistantRequiredInCartDrawer();
  }
}

function checkHeatResistantRequiredInCartDrawer() {
  const drawerCartItemsSelector = '.cart-item';
  const targetSection = 'cart-drawer';
  const targetElements = targetCartPageNDrawerElementsForRemoving();
  setCartPageNDrawerUILoadingForUpdation(targetElements);
  fetch(window.location.pathname + `?sections=${targetSection}`)
  .then(response => response.json())
  .then(data => {
    const drawerCartItems = getTargetCartDrawerItems(
      data,
      targetSection,
      drawerCartItemsSelector
    );
    if (!drawerCartItems) return resetCartPageNDrawerUILoadingForUpdation(
      targetElements
    );
    const {
      requiredRemoval,
      heatResistantId
    } = isHeatResistantEligibleForRemoval(
      drawerCartItems
    );
    if (!requiredRemoval) return resetCartPageNDrawerUILoadingForUpdation(
      targetElements
    );
    removeHeatResistantProductFromCart(heatResistantId, targetElements);
  })
  .catch(error => {
    console.error('Error[checkHeatResistantRequiredInCartDrawer]:', error);
    resetCartPageNDrawerUILoadingForUpdation(targetElements);
  });
}

function renderProperProceedToOption(cartData) {
  const cartItemsWithSubscriptions = (cartData?.items || []).filter(
    (item) => item?.selling_plan_allocation,
  );
  const proceedToCheckout = document.querySelector(
    '[data-cart-proceed-to="checkout"]',
  );
  const proceedToAddress = document.querySelector(
    '[data-cart-proceed-to="address"]',
  );
  if (cartItemsWithSubscriptions.length) {
    if (proceedToAddress) proceedToAddress.style.display = "none";
    if (proceedToCheckout) proceedToCheckout.style.display = "block";
  } else {
    if (proceedToCheckout) proceedToCheckout.style.display = "none";
    if (proceedToAddress) proceedToAddress.style.display = "block";
  }
}

function isItCartPage() {
  return window.location.pathname === CART_PAGE_PATHNAME;
}

function targetCartPageNDrawerElementsForRemoving() {
  let targetElements = [
    '#cart-icon-bubble',
    '#cart-icon-bubble-mob',
  ];
  if (isItCartPage()) {
    targetElements = targetElements.concat(
      [
        '.shipping-cart-box',
        '#main-cart-footer > .order-sum'
      ]
    );
  } else {
    targetElements = targetElements.concat(
      [
        '#CartDrawer-CartItems .cart-item'
      ]
    );
  }
  return targetElements;
}

function getSectionsNeedToRenderAfterRemoving() {
  let sections = [
    {
      section: 'cart-icon-bubble',
      selectors: [
        {
          source: '#cart-icon-bubble',
          target: '#shopify-section-cart-icon-bubble'
        }
      ],
    },
    {
      section: 'header-custom',
      selectors: [
        {
          source: '#cart-icon-bubble-mob',
          target: '#cart-icon-bubble-mob'
        }
      ],
    },
  ];
  if (isItCartPage()) {
    sections = sections.concat(
      [
        {
          section: document.getElementById('main-cart-footer').dataset.id,
          selectors: [
            {
              source: '#main-cart-footer',
              target: '#main-cart-footer'
            }
          ],
        },
      ]
    );
  } else {
    sections = sections.concat(
      [
        {
          section: 'cart-drawer',
          selectors: [
            {
              source: 'cart-drawer-items',
              target: 'cart-drawer-items'
            },
            {
              source: '.cart-drawer__footer',
              target: '.cart-drawer__footer'
            }
          ]
        },
      ]
    );
  }
  return sections;
}

function getTargetCartDrawerItems(
  data,
  targetSection,
  drawerCartItemsSelector
) {
  if (!Object.keys(data).length) return null;
  if (!(targetSection in data)) return null;
  const html = new DOMParser().parseFromString(
    data[targetSection],
    'text/html'
  );
  return html.querySelectorAll(drawerCartItemsSelector);
}

function isHeatResistantEligibleForRemoval(drawerCartItems) {
  let heatResistantVariantExistsInCart = false;
  let heatResistantRequiredInCart = false;
  let heatResistantId = "";
  for (const drawerCartItem of drawerCartItems) {
    const productId = drawerCartItem.getAttribute("data-product-id") || null;
    const variantId = drawerCartItem.getAttribute("data-variant-id") || null;
    const heatResistantVariantId = drawerCartItem.getAttribute(
      "data-heat-resistant-variant-id"
    ) || null;
    const heatResistantRequired = drawerCartItem.getAttribute(
      "data-heat-resistant-required"
    ) || null;

    if (productId
      && variantId
      && heatResistantVariantId
      && heatResistantRequired
    ) {
      if (String(variantId).trim() === String(heatResistantVariantId).trim()) {
        heatResistantVariantExistsInCart = true;
        heatResistantId = String(heatResistantVariantId).trim();
      }
      if (String(heatResistantRequired).trim() === HEAT_RESISTANT_REQUIRED) {
        heatResistantRequiredInCart = true;
      }
    }
  }
  const requiredRemoval = (
    heatResistantVariantExistsInCart
    && !heatResistantRequiredInCart
    && heatResistantId
  );
  return { requiredRemoval, heatResistantId };
}

function removeHeatResistantProductFromCart(heatResistantId, targetElements) {
  let updates = {};
  updates[heatResistantId] = 0;
  const url = window.Shopify.routes.root + `cart/update.js`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  };
  fetch(url, options)
  .then((response) => response.json())
  .then((responseJson) => {
    if (Array.isArray(responseJson?.items || {})) {
      window.location.reload(true);
    } else {
      let errorMessage = defaultErrorMsg;
      if ((responseJson?.status !== 200) && responseJson?.description) {
        errorMessage = responseJson.description;
      }
      console.error(errorMessage);
      resetCartPageNDrawerUILoadingForUpdation(targetElements);
    }
  })
  .catch((e) => {
    console.error(e);
    resetCartPageNDrawerUILoadingForUpdation(targetElements);
  });
}

async function isApplyHeatResistantSetting(){
  const url = `${SHOPIFY_APP_BASE_URL_settings}/get-app-settings`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
    });

    const responceData = await response.json();
    if (responceData.status === 'ok') {
      return responceData.data.autoApplyHeatResistant;
    } else {
      return false;
    }
  } catch (error) {
    console.error('Error:', error);
    return false;
  }
}
